import React , {useEffect} from "react";
import gsap from 'gsap'
import {  VisibilityContext } from 'react-horizontal-scrolling-menu';
import { json } from "react-router-dom";


function ProjectCard({ onClick,image ,itemId, link}) {
    const visibility = React.useContext(VisibilityContext);


    useEffect(()=>{
        gsap.fromTo('.project-card',
            { opacity: 0, y: 50 },
            { opacity: 1, y: 0, duration: 0.5, ease: 'power2.out',
              scrollTrigger: {
                trigger: '.project-card',
                start: 'top 100%',
                toggleActions: 'play none none none'
              }
            }
          );  
        },[])
  
    return (
      <div
        onClick={() => onClick(visibility)}
        style={{ height: '70vh', width: '300px' }}
        tabIndex={0}
        className='ms-5 onHover'
      >
      
        <div style={{ 'backgroundImage': `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),url(${image})`,'backgroundSize': 'cover', 'backgroundRepeat': 'no-repeat', 'backgroundPosition': 'center'}} className="onHover project-card border rounded-5">
         {link !== null ? <a style={{height:'vh', pointerEvents:'visible'}} className="d-flex justify-content-end  min-height-100  h-100" href={link} target="_blank">
      </a> : ''} 
        </div>
        <div
          style={{
            height: '200px',
          }}
        />
      <h1 className="text-primary">     {link | json}</h1>
 
      </div>
    );
  }
  
  export default ProjectCard;
  